module.exports = __webpack_public_path__ + "img/fadada.250890f9.svg";